import { ReactComponent as SuccessSvg } from '@/images/icons/alert/success.svg';
export default SuccessSvg;
